import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'password-validate',
    components: {
    },
})

export default class PasswordValidate extends Vue {

    @Prop({ default: '' })
    private value: any;

    private newPw: any = '';

    private showPasswordstatus: boolean = false;

    private reqirementsMessage: any = [
        { key: 'cLength', message: 'Password should be 8 - 15 characters long', isAchived: true },
        { key: 'lCaps', message: 'Should contain at least one capital case letter', isAchived: false },
        { key: 'sCaps', message: 'Should contain at least one small case letter', isAchived: false },
        { key: 'digit', message: 'Should contain at least one digit', isAchived: false },
        { key: 'sChar', message: 'Should contain at least one special character (!@#$%^&*()_+=)', isAchived: false },
    ];

    private created() {
        this.newPw = this.value;
    }

    private validatePassword(textPW: any) {
        this.$bvToast.show('password-validate-toast');
        this.$emit('updatingPw', textPW);
        const uppercase = /[A-Z]/g;
        const lowercase = /[a-z]/g;
        const numberReg = /[0-9]/g;
        const specialAllow = /[ !@#$%^&*()_+=]/g;
        const regexSplNotAllow = /[ \s\-\[\]{};':"\\|,.<>\/?]/g;
        for (const iterator of this.reqirementsMessage) {
            iterator.isAchived = true;
        }
        if (textPW.length < 8 || textPW.length > 15) {
            this.indexOfError('cLength');
        }
        if (!uppercase.test(textPW)) {
            this.indexOfError('lCaps');
        }
        if (!lowercase.test(textPW)) {
            this.indexOfError('sCaps');
        }
        if (!numberReg.test(textPW)) {
            this.indexOfError('digit');
        }
        if (regexSplNotAllow.test(textPW) || !specialAllow.test(textPW)) {
            this.indexOfError('sChar');
        }
    }

    private indexOfError(key: any) {
        const errorIndex = this.reqirementsMessage.findIndex((item: any) => item.key === key);
        this.reqirementsMessage[errorIndex].isAchived = false;
    }
}
